module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_left_primary-f2863bd87860d952688054887b7705e9.svg";